var initializeBlockLogoGrid = function(block){
	
	var groupCount = 8;
	var originalCount = jQuery("ul li", block).length;
    
	jQuery("ul li:lt(" + groupCount + ")", block).addClass("show");
	
	jQuery(".load-more", block).on("click", function(){
		
		jQuery("ul li:not(.show):lt(" + groupCount + ")", block).addClass("show");
		
		var newCount = jQuery("ul li.show", block).length;
		
		if(newCount >= originalCount) {
			jQuery(this).hide();
		}
		
	});
    
} 

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-logo-grid').each(function(){
        initializeBlockLogoGrid(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=logo-grid', initializeBlockLogoGrid);
